import MuiStack from '@mui/material/Stack';
import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

export interface StackProps {
  spacing?: number;
  direction?: 'row' | 'column';
  sx?: SxProps<Theme>;
  children?: ReactNode;
}

export function Stack({ spacing, direction, sx, children }: StackProps) {
  // Forward optionals only when set (exactOptionalPropertyTypes).
  return (
    <MuiStack
      {...(spacing !== undefined ? { spacing } : {})}
      {...(direction !== undefined ? { direction } : {})}
      {...(sx !== undefined ? { sx } : {})}
    >
      {children}
    </MuiStack>
  );
}
